import Axios, { AxiosRequestConfig } from 'axios';
// core
import CoreDefaults from '@/core/Defaults';
// interfaces
import TFetchExtension from '@/core/types/TFetchExtension';
// utilities
import odataQueryComposer from '@/utilities/OdataQueryComposer';


declare module "axios" {
  export interface AxiosRequestConfig {
    responseEncoding?: string;
  }
}

const FetchExtension = async( params: TFetchExtension ) : Promise<any> => {
    console.log("FetchExtension.params: ", params);

    const baseUrl = `${CoreDefaults.api}/${params.protocol ?? CoreDefaults.fetchSettings.protocol}/${params.sourcePath}`;
    const url: string = odataQueryComposer(baseUrl, params.queryOptions);

    const axiosConfig: AxiosRequestConfig = {
        url,
        method: params.method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': params.contentType || 'application/json',
            'Accept-Language': params.language || CoreDefaults.clientLanguage.code
        },
        responseType: 'json',
        responseEncoding: 'utf8',
        validateStatus: (status: number) => {
            return CoreDefaults.acceptableHttpStatus.indexOf(status) > -1;
        }
    }

    const tenant = localStorage.getItem("TENANT");
    if ( tenant && axiosConfig["headers"] ) {
        axiosConfig["headers"]["Tenant-Hierarchy"] = tenant;
    }

    if ( params.body || params.formData ) {
        axiosConfig.data = params.formData ? params.formData : JSON.stringify(params.body);
    }

    return Axios(axiosConfig);
}

export default FetchExtension;